import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { ProductIntro } from './ProductIntro';
import { TomosList } from './TomosList';
import { Bonos } from './Bonos';
import { BeforeAfter } from './BeforeAfter';
import { Beginners } from './Beginners';
import { SummerCollection } from './SummerCollection';
import { ValueStack } from './ValueStack';
import { Urgency } from './Urgency';
import { Pricing } from './Pricing';
const LateContent = lazy(() => import('./LateContent').then(({
  LateContent: Content
}) => ({
  default: Content
})));
interface DeferredContentProps {
  onCta: () => void;
  onReady: () => void;
}

/** Long-form sales content stays outside the critical rendering path. */
export function DeferredContent({
  onCta,
  onReady
}: DeferredContentProps) {
  const lateContentTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadLateContent, setShouldLoadLateContent] = useState(false);
  useEffect(() => {
    onReady();
  }, [onReady]);
  useEffect(() => {
    const trigger = lateContentTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadLateContent(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadLateContent(true);
      observer.disconnect();
    }, {
      rootMargin: '420px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  return <>
      <ProductIntro data-id="element-49" data-mp="2r5fr74nz6zgm" />
      <TomosList data-id="element-50" data-mp="2r44oz9a6hzrm" />
      <Bonos data-id="element-51" data-mp="2r6qvr6p8wb8s" />
      <BeforeAfter data-id="element-52" data-mp="2r70kys2guedf" />
      <Beginners data-id="element-53" data-mp="3545skwhtvlas" />
      <SummerCollection data-id="element-54" data-mp="354p5fysmfjhy" />
      <ValueStack data-id="element-55" data-mp="353vz2yxkqw0c" />
      <Urgency data-id="element-56" data-mp="352bd3xpbsle3" />
      <div id="pricing" className="scroll-mt-4" data-id="element-57" data-mp="312u7935zlm8e">
        <Pricing data-id="element-58" data-mp="3145a90rlypyg" />
      </div>
      <div ref={lateContentTriggerRef} className="h-px" aria-hidden="true" data-id="element-59" data-mp="310psfq6jv2tc" />
      {shouldLoadLateContent && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-61" data-mp="16p2q7ilbw02x" />} data-id="element-60" data-mp="1as7rxixl3xqi">
          <LateContent onCta={onCta} data-id="element-62" data-mp="16qm79bet6f5r" />
        </Suspense>}
    </>;
}